export enum PageType {
  CUSTOM_PAGE = 'customPage',
  DOCUMENT_PAGE = 'documentPage',
  EXTERNAL_PAGE = 'externalPage'
}
